import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ShareAuthGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    // Check if user is authenticated
    const accessToken = localStorage.getItem('accessToken');
    const userId = localStorage.getItem('userId');

    if (accessToken && userId) {
      // User is authenticated, allow access
      return true;
    }

    // User is not authenticated - redirect to login/registration with returnUrl
    const queryParams = route.queryParams;
    const code = queryParams['code'] || null;
    const email = queryParams['email'] || null;
    const fileId = route.params['fileId'] || null;
    const folderId = route.params['folderId'] || null;

    // Build returnUrl preserving all query params
    const returnUrl = state.url;

    // Determine if this is a share link (has code param)
    if (code) {
      // This is a share link - need to validate token and determine if user needs registration
      // For now, redirect to login with returnUrl
      // The login/registration flow will handle token validation
      this.router.navigate(['/auth/login'], {
        queryParams: {
          returnUrl: returnUrl,
          code: code,
          email: email,
        },
      });
    } else {
      // Regular shared route access - just redirect to login
      this.router.navigate(['/auth/login'], {
        queryParams: {
          returnUrl: returnUrl,
        },
      });
    }

    return false;
  }
}

